import { AddUpdateTaskParams, Task } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

type Variables = AddUpdateTaskParams

export function useAddTask() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: addTask,
    onSuccess: async (_, variables) => {
      // Invalidate queries
      await client.invalidateQueries({ queryKey: keys.all })
    },
  })

  async function addTask(taskData: Variables) {
    const { storeId, assignedTo, ...data } = taskData
    const response = await server.post<Task>(
      `v2/tasks/custom/user/${storeId}/${assignedTo}`,
      {
        summary: data.summary,
        description: data.description,
        due_date: data.dueDate,
        new_due_date: data.newDueDate,
        photo_required: data.photoRequired,
        recurring: data.recurring,
        frequency: data.frequency,
        interval: data.interval,
        monthly_on: data.monthlyOn,
        by_day: data.byDay,
        until: data.until,
      }
    )
    return response
  }
}
